import { render, staticRenderFns } from "./TrainingsFinishModal.vue?vue&type=template&id=545b0d57&scoped=true"
import script from "./TrainingsFinishModal.vue?vue&type=script&lang=js"
export * from "./TrainingsFinishModal.vue?vue&type=script&lang=js"
import style0 from "./TrainingsFinishModal.vue?vue&type=style&index=0&id=545b0d57&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "545b0d57",
  null
  
)

export default component.exports